import { Button } from "@/components/ui/button";
import { useLandingLanguage } from "@/hooks/useLandingLanguage";

export const LanguageToggle = () => {
  const { lang, setLang } = useLandingLanguage();

  return (
    <div className="flex items-center gap-0.5 border border-border rounded-full p-0.5 bg-background/50">
      <Button
        variant={lang === "it" ? "default" : "ghost"}
        size="sm"
        onClick={() => setLang("it")}
        className="rounded-full px-2.5 py-1 h-7 text-xs font-medium"
      >
        🇮🇹 IT
      </Button>
      <Button
        variant={lang === "en" ? "default" : "ghost"}
        size="sm"
        onClick={() => setLang("en")}
        className="rounded-full px-2.5 py-1 h-7 text-xs font-medium"
      >
        🇬🇧 EN
      </Button>
    </div>
  );
};
